/* eslint-disable no-use-before-define */
// LockService.js
import { getSocketClient } from './socket';

class LockService {
    static requestLock(componentId, actionName, timeout = 5000) {
        // eslint-disable-next-line consistent-return
        return new Promise((resolve, reject) => {
            const socket = getSocketClient();
            if (!socket) {
                return resolve(false);
            }
            socket.emit('LOCK_REQUEST', { componentId, actionName });

            const cleanup = () => {
                socket.off('LOCK_ACQUIRED', onLockAcquired);
                socket.off('LOCK_IN_USE', onLockInUse);
                socket.off('LOCK_ERROR', onLockError);
                clearTimeout(timeoutId);
            };

            const onLockAcquired = payload => {
                if (payload.componentId === componentId && payload.actionName === actionName) {
                    cleanup();
                    resolve(true);
                }
            };

            const onLockInUse = payload => {
                if (!payload.componentId || (payload.componentId === componentId && payload.actionName === actionName)) {
                    cleanup();
                    resolve(false);
                }
            };

            const onLockError = payload => {
                if (!payload.componentId || (payload.componentId === componentId && payload.actionName === actionName)) {
                    cleanup();
                    reject(new Error(payload.errorMessage || 'Lock error'));
                }
            };

            socket.on('LOCK_ACQUIRED', onLockAcquired);
            socket.on('LOCK_IN_USE', onLockInUse);
            socket.on('LOCK_ERROR', onLockError);

            const timeoutId = setTimeout(() => {
                cleanup();
                reject(new Error(`Lock request timed out for componentId=${componentId}, action=${actionName}`));
            }, timeout);
        });
    }

    static releaseLock(componentId, actionName) {
        return new Promise(resolve => {
            const socket = getSocketClient();
            if (socket) {
                socket.emit('LOCK_RELEASE', { componentId, actionName });
            }
            const onLockReleased = data => {
                if (data.componentId === componentId) {
                    cleanup();
                    resolve(true);
                    if (window?.$store) {
                        window.$store.dispatch('resetLockFrom');
                    }
                } else if (!data.success) {
                    cleanup();
                    resolve(false);
                } else {
                    cleanup();
                    resolve(false);
                }
            };
            const cleanup = () => {
                socket.off('LOCK_RELEASED', onLockReleased);
                socket.off('LOCK_BROADCAST_RELEASED', onLockReleased);
                clearTimeout(timeoutId);
            };

            socket.once('LOCK_RELEASED', onLockReleased);
            socket.once('LOCK_BROADCAST_RELEASED', onLockReleased);

            const timeoutId = setTimeout(() => {
                cleanup();
                if (window?.$store) {
                    window.$store.dispatch('resetLockFrom');
                }
                resolve(true);
            }, 2500);
        });
    }

    static getLockStatus(componentId, actionName) {
        return new Promise(resolve => {
            const socket = getSocketClient();
            if (socket) {
                socket.emit('GET_LOCK_STATUS', { componentId, actionName });

                socket.once('LOCK_STATUS', response => {
                    if (response.success) {
                        resolve(response.available);
                    } else {
                        resolve(false);
                    }
                });
            }
            setTimeout(() => {
                resolve(false);
            }, 2500);
        });
    }
}

export default LockService;
